/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetAllHoldoutsPathParams = NonNullable<operations['getAllHoldouts']['parameters']['path']>;

export type GetAllHoldoutsQueryParams = NonNullable<operations['getAllHoldouts']['parameters']['query']>;

export interface Input extends GetAllHoldoutsPathParams {
  apiVersion?: string;
  query?: GetAllHoldoutsQueryParams;
}

export async function getAllHoldouts(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/environments/{environmentKey}/holdouts', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
